export default __webpack_public_path__ + "static/media/Family Friendly.4d285592.jpg";